import React, { useLayoutEffect, useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Col, Row, Form, Container, Button, Spinner, Image } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import { states } from '../../../../utils/states'
import { IMaskInput } from 'react-imask'
import UserCircle from '../../../../assets/UserCircle.svg'

import ConfirmationModal from '../../../../components/ConfirmationModal'

import styles from './styles.module.css'
import { useLoading } from '../../../../hooks/LoadingContext'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'

const MotoristasEditar: React.FC = () => {
  let { id } = useParams()
  const [name, setName] = useState<string>('')
  const [gender, setGender] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [city, setCity] = useState<string>('')
  const [state, setState] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  const [profile_picture_url, setProfilePictureUrl] = useState<string>('')
  const [accountValidated, setAccountValidated] = useState<boolean>()

  const { isLoading, setIsLoading } = useLoading()
  const [profilePicture, setProfilePicture] = useState<File | null>()

  const [showModalValidate, setShowModalValidate] = useState(false)
  const handleCloseModalValidate = () => setShowModalValidate(false)
  const handleShowModalValidate = () => {
    setShowModalValidate(true)
  }

  const navigate = useNavigate()

  const clearFileInput = (e: any) => {
    const filesData = new DataTransfer()
    e.target.files = filesData.files
  }

  const handlePictureChange = (e: any) => {
    if (e.target.files) {
      const file = e.target.files[0]
      const fileType = file.name.split('.')[1].toLowerCase()

      if (!['jpg', 'png', 'gif', 'jpeg'].includes(fileType)) {
        toast.error('A foto deve possuir formato .PNG, .JPG, .JPEG ou .GIF')
        clearFileInput(e)
        setProfilePicture(null)
        setProfilePictureUrl(UserCircle)
      } else {
        setProfilePicture(e.target.files[0])
        const url = URL.createObjectURL(e.target.files[0])
        setProfilePictureUrl(url)
      }
    }
  }

  useLayoutEffect(() => {
    setIsLoading(true)
    async function loadData() {
      try {
        const { data } = await api.get(`/company/drivers/${id}?profile_picture=true`)

        setName(data.name)
        setGender(data.gender)
        setPhone(data.phone)
        setCity(data.city)
        setState(data.state)
        setEmail(data.user.email)
        setAccountValidated(data.account_validated)
        if (data.profilePicture) setProfilePictureUrl(data.profilePicture.url)
        else setProfilePictureUrl(UserCircle)
      } catch (err) {
        toast.error('Falha ao buscar os dados! Atualize a página.')
      }
      setIsLoading(false)
    }
    loadData()
  }, [id, setIsLoading])

  const handleChangeValidation = async (event: any) => {
    event.preventDefault()
    setIsLoading(true)

    try {
      let data = new FormData()
      data.append('data', JSON.stringify({ account_validated: !accountValidated }))
      await api.put(`/company/drivers/${id}`, data)
      toast.info('Motorista atualizado com sucesso!', { autoClose: 3000 })
      setIsLoading(false)
      navigate('/empresa/motoristas/listar')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao invalidar o motorista! Tente novamente.'))
      setIsLoading(false)
    }
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!name || !gender || !phone || !city || !state || !email) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }

    const data = new FormData()
    const model = {
      name: name,
      gender: gender,
      phone: phone,
      city: city,
      state: state,
      email: email,
    }
    data.append('data', JSON.stringify(model))
    if (profilePicture) data.append('image', profilePicture, profilePicture.name)

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    try {
      await api.put(`/company/drivers/${id}`, data, config)

      setIsLoading(false)
      toast.info('Motorista atualizado com sucesso!', { autoClose: 3000 })
      navigate('/empresa/motoristas/listar')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao atualizar o motorista! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return name && gender && phone && city && state && email
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Editar motoristas">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Atualizar dados do motorista</h2>
        <Col style={{ textAlign: 'center' }}>
          <Image
            style={{ height: 150, width: 150, borderRadius: 12 }}
            fluid={true}
            src={profile_picture_url}
          />
        </Col>
        <Col className={styles.form_container}>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Foto de perfil (opcional)
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="file"
                placeholder="Selecione a foto de perfil"
                onChange={(event) => {
                  handlePictureChange(event)
                }}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Gênero*
              </Form.Label>
              <Form.Select
                className={styles.input}
                value={gender}
                onChange={(event) => setGender(event.target.value)}
              >
                <option value="">Selecione o gênero</option>
                <option value="male">Masculino</option>
                <option value="female">Feminino</option>
                <option value="other">Outro</option>
              </Form.Select>
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Telefone*
              </Form.Label>
              <Form.Control
                className={styles.input}
                as={IMaskInput}
                mask={[
                  { mask: '(00) 00000000' }, // para números fixos (8 dígitos)
                  { mask: '(00) 000000000' }, // para números de celular (9 dígitos)
                ]}
                placeholder="Digite aqui o telefone"
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Cidade*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a cidade"
                value={city}
                onChange={(event) => setCity(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Estado/UF*
              </Form.Label>
              <Form.Select
                className={styles.input}
                value={state}
                onChange={(event) => setState(event.target.value)}
              >
                <option value="">Selecione o estado</option>
                {states.map((state) => (
                  <option key={state}>{state}</option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                E-mail*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o e-mail"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 15 }}>
            <Col style={{ textAlign: 'right' }} className="mt-md-0 mt-3">
              {accountValidated ? (
                <Button
                  className={`${styles.btn} ${styles.btn_delete}`}
                  disabled={isLoading}
                  onClick={handleShowModalValidate}
                >
                  Invalidar motorista
                </Button>
              ) : (
                <Button
                  className={`${styles.btn}`}
                  variant="success"
                  disabled={isLoading}
                  onClick={handleShowModalValidate}
                >
                  Validar motorista
                </Button>
              )}

              <Button
                className={`${styles.btn} ${styles.btn_edit}`}
                disabled={isLoading || !isValidModel()}
                onClick={handleSubmit}
              >
                {isLoading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{
                      color: '#fff',
                      marginRight: 10,
                    }}
                  />
                ) : (
                  'Atualizar motorista'
                )}
              </Button>
            </Col>
          </Row>
        </Col>
      </Container>
      <ConfirmationModal
        show={showModalValidate}
        message={`Tem certeza de que deseja ${accountValidated ? 'invalidar' : 'validar'} o motorista?`}
        action={handleChangeValidation}
        closeModal={handleCloseModalValidate}
      ></ConfirmationModal>
    </DashboardLayout>
  )
}

export default MotoristasEditar
